import React from 'react';
import PropTypes from 'prop-types';
import Header from 'cccisd-header';
import style from './style.css';

export default class PrimaryNavBar extends React.Component {
    static propTypes = {
        className: PropTypes.string,
    };

    static defaultProps = {
        className: 'container-fluid',
    };

    render() {
        const Fortress = window.cccisd.fortress;
        const primaryNavLinks =
            Fortress && Fortress.auth() && Fortress.user.acting.role.handle !== 'learner'
                ? [{ url: '/rolePicker', label: 'My Account' }]
                : [];

        return (
            <Header
                containerClassName="container-fluid"
                logoClassName={style.logo}
                logoLink="https://www.schoolhealthdata.org/"
                primaryNavLinks={primaryNavLinks}
                showAlertAction={false}
                showAdminAction={Fortress && Fortress.isSuperUser() ? true : false}
            />
        );
    }
}
